import {Text} from '@/components/ui/text/Text'
import styled from 'styled-components'

export const StyledProjectWorkingDays = styled(Text)`
    height: 32px;
    align-content: center;
`
